// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"

// import "trix"
// import "@rails/actiontext"

// import bootstrap from "bootstrap/dist/js/bootstrap.bundle"
// import "bootstrap/dist/js/bootstrap.bundle"
// import "./src/bootstrap.js";

import "./src/jquery.js";
import "./src/jquery_ui.js";
import "jquery-toast-plugin/src/jquery.toast.js";
import "./src/datetime_picker.js";

// import $ from "jquery";
// import jQuery from "jquery";
// var jQuery = require("jquery");

// import jQuery from "./jquery.module.js"
// window.$ = window.jQuery = jQuery
// import 'jquery-ui'
// import 'popper.js'

import "jquery.appear";
import "./navbar.js";

// import * as bootstrap from "bootstrap"

import "./controllers";
import "./tinymce.js";
import "./datetime-picker.js";
import "./flash_message.js";
import "./common";

import "./outreach_messages";
import "./tracker/tasks.js";

// console.log($.fn.jquery);
// console.log(jQuery.fn.jquery);
// console.log($.ui.version);
// console.log(jQuery.ui.version);
// console.log(InlineEditor);

// import "@fortawesome/fontawesome-free/js/all";
import "./tabs.js";
